import $ from "jquery";
import {Message} from "./Message";

export class Chatroom {

  constructor(el, reactions, addScoreCallback, lang = 'en') {
    this.$el = $(el);
    this.addScoreCallback = addScoreCallback;

    this.$messages = this.$el.find(".chat-messages");
    this.$keyboard = $(".keyboard-chat");
    this.message = new Message(this.$messages);
    this.reactions = reactions;
    this.lang = lang;

    this.scoreMap = {
      "dont_like": 1,
      "not_really": 2,
      "meh": 3,
      "like": 4,
      "love": 5
    }
  }

  waitForUser() {
    this.$keyboard.addClass("active");

    return new Promise((resolve) => {
      $(".chat-choice-btn").off(app.touchEvent).one(app.touchEvent, (e) => {
        e.stopPropagation();
        this.$keyboard.removeClass("active");
        const key = $(e.currentTarget).data("reaction");
        resolve(key);
      });
    });
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async runSteps(steps) {
    this.aborted = false;
    let lastMessage = null;
    let lastReaction = null;

    for (const step of Object.values(steps)) {
      if (this.aborted) return;

      try {
        switch (step.type) {
          case 'message':
            await this.message.addMessage(step.text[this.lang], 'left');
            lastMessage = step;
            break;
          case 'wait_for_user':
            const key = await this.waitForUser();
            lastReaction = this.reactions[key];

            // Reset interaction timeout
            app.resetTimer()

            // Handle user choice and score
            const isPositive = ["like", "love"].includes(key);
            this.addScoreCallback(lastMessage.sector, this.scoreMap[key]);

            // Add user message/emoji to the chatroom
            await this.message.addEmojiAndMessage(lastReaction.user.text[this.lang], lastReaction.user.icon, 'right', "0.5");

            // Add bot feedback/emoji to the chatroom
            await this.message.addEmojiAndMessage(lastMessage.bot_feedback[isPositive ? "positive" : "negative"][this.lang], lastReaction.bot.icon, 'left', 0);
            break;
        }


      } catch (err) {
        console.warn(`Chatroom step failed (type=${step.type}):`, err);
      }

      // Add a pause before continuing to next step and default to 1s pause
      await this.wait(step.pause_after ?? 1000);
    }
    if (this.aborted) return;

    this.complete();
  }

  complete() {
    this.message.scrollToTop();
  }

  reset() {
    this.aborted = true;
    this.message.reset();
    this.$keyboard.removeClass("active visible entered");
  }
}
